import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useGetPriceSegment } from "../../../../../../../../hooks/modules/EcommContent/hooks/use-get-price-segment.js";
import { BookAppointmentCTA } from "../../../../../../../../components/CTAs/BookAppointmentCTA/modules/EcommContent/components/CTAs/BookAppointmentCTA/BookAppointmentCTA.js";
import { FindAStoreCTA } from "../../../../../../../../components/CTAs/FindAStoreCTA/modules/EcommContent/components/CTAs/FindAStoreCTA/FindAStoreCTA.js";
import { CLAddToCartCTA } from "../../../../../components/CLAddToCartCTA/modules/EcommContent/ContactLensesEcommContent/components/ContactLensesCTA/components/CLAddToCartCTA/CLAddToCartCTA.js";
import { DummyAddToCartCTA } from "../../../../../components/DummyAddToCartCTA/modules/EcommContent/ContactLensesEcommContent/components/ContactLensesCTA/components/DummyAddToCartCTA/DummyAddToCartCTA.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
import { useCLEcommContext } from "../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
import { isSinglePurchase, isInStoreSubscriptionPurchase } from "../../../../../../../../../../types/types/typeguards.js";
const ContactLensesCTA = ({ className }) => {
  const { isContactLensEnabled } = useFeatureToggles();
  const { routes, activeVariant } = useProductData();
  const { priceSegment } = useGetPriceSegment();
  const storesRoute = routes.stores;
  const { state, selectors } = useCLEcommContext();
  const [isConfiguratorValid] = selectors.isConfiguratorValid(state);
  const hasNonOrderableProduct = selectors.hasNonOrderableProduct(state);
  const lineItemDrafts = selectors.getLineItemDrafts(
    state,
    isSinglePurchase(state.configurations.purchaseType) ? priceSegment : void 0
  );
  if (isInStoreSubscriptionPurchase(state.configurations.purchaseType)) {
    return /* @__PURE__ */ React.createElement(BookAppointmentCTA, { className, href: storesRoute });
  }
  if (activeVariant.isExcludedFromCheckout || hasNonOrderableProduct) {
    return /* @__PURE__ */ React.createElement(FindAStoreCTA, { className, href: storesRoute });
  }
  if (!isContactLensEnabled) {
    return /* @__PURE__ */ React.createElement(BookAppointmentCTA, { className, href: storesRoute });
  }
  if (isContactLensEnabled && isConfiguratorValid && lineItemDrafts.length > 0) {
    return /* @__PURE__ */ React.createElement(CLAddToCartCTA, { className, lineItemDrafts });
  }
  return /* @__PURE__ */ React.createElement(DummyAddToCartCTA, { className });
};
export {
  ContactLensesCTA
};
//# sourceMappingURL=ContactLensesCTA.js.map
